function LocationMenuButton(props) {
  const { name, action } = props;

  return (
    <div className="locationmenubutton" onClick={action}>
      { name }
    </div>
  );
}

export default LocationMenuButton;
